export function showUnderTrainingBot(
  isIframe: boolean,
  isIframePreview: boolean,
  useAsPreview: boolean,
  isBotDataTrained: boolean,
) {
  const isUntrained = !isBotDataTrained;
  const isUntrainedInIframePreviewMode =
    isIframe && isIframePreview && isUntrained;
  const isUntrainedInWidgetPreviewMode = useAsPreview && isUntrained;

  if (isUntrainedInIframePreviewMode || isUntrainedInWidgetPreviewMode) {
    return true;
  }

  return false;
}
